import axios from "axios";
import qs from "qs";
var base = "";

if (window.location.hostname === "localhost") {
  base = "https://itt-ft.effective-wechat.com/api";
} else {
  base = "https://itt-ft.effective-wechat.com/api";
}

export const getCategories = (params) => {
  return axios.get(`${base}/categories`, params).then((res) => res.data);
};
export const getCategory = (params) => {
  return axios.get(`${base}/categories/${params.id}`, params).then((res) => res.data);
};
export const updateProfile = (params) => {
  return axios.put(`${base}/profile`, params).then((res) => res.data);
};
export const createMessage = (params) => {
  return axios.post(`${base}/contact`, params).then((res) => res.data);
};
export const getProfile = (params) => {
  return axios.get(`${base}/profile`, params).then((res) => res.data);
};
export const sendMail = (params) => {
  return axios.post(`${base}/sendmail`, params).then((res) => res.data);
};
export const sendVerify = (params) => {
  return axios.post(`${base}/register/verify`, params).then((res) => res.data);
};
export const wechatLogin = (params) => {
  return axios.get(`${base}/login?${qs.stringify(params)}`, params).then((res) => res.data);
};

export const valveSearch = (params) => {
  return axios.post(`${base}/valve/search`, params).then((res) => res.data);
};
export const getPumpTypes = (params) => {
  return axios.get(`${base}/pump/types?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getPumpModels = (params) => {
  return axios.get(`${base}/pump/models?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getPumpPartTypes = (params) => {
  return axios.get(`${base}/pump/parttypes?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getPumpSpecs = (params) => {
  return axios.get(`${base}/pump/specs?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getPumpMaterials = (params) => {
  return axios.get(`${base}/pump/materials?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const pumpSearch = (params) => {
  return axios.post(`${base}/pump/search`, params).then((res) => res.data);
};

export const partSearch = (params) => {
  return axios.post(`${base}/part/search`, params).then((res) => res.data);
};

export const getProductSizes = (params) => {
  return axios.get(`${base}/product/sizes?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getProductTypes = (params) => {
  return axios.get(`${base}/product/types?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getProductModels = (params) => {
  return axios.get(`${base}/product/models?${qs.stringify(params)}`, params).then((res) => res.data);
};

export const getPartMaterials = (params) => {
  return axios.get(`${base}/part/materials`, params).then((res) => res.data);
};

export const searchProduct = (params) => {
  return axios.get(`${base}/product/search?${qs.stringify(params)}`, params).then((res) => res.data);
};

export const getBrands = (params) => {
  return axios.get(`${base}/brands?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getBrand = (params) => {
  return axios.get(`${base}/brands/${params.id}`, params).then((res) => res.data);
};
export const getApplications = (params) => {
  return axios.get(`${base}/applications?${qs.stringify(params)}`, params).then((res) => res.data);
};
export const getApplication = (params) => {
  return axios.get(`${base}/applications/${params.id}`, params).then((res) => res.data);
};

export const deviceRegistration = (params) => {
  return axios.post(`${base}/device/reg`, params).then((res) => res.data);
};

export const registration = (params) => {
  return axios.post(`${base}/register`, params).then((res) => res.data);
};

export const uploadImg = (file) => {
  let params = new FormData();
  params.append("file", file);
  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${base}/files`, params, config).then((res) => res.data);
};
